import { gql } from 'graphql-tag'
import fragmentModuleMedia from '../../../../core/data-layer/modules/module-media/fragment-module-media'
import fragmentModuleNavigationLink from '../../../../core/data-layer/modules/module-navigation-link/fragment-module-navigation-link'
import fragmentGlobalDataTheme from '../../../../core/data-layer/global-data/global-data-theme/fragment-global-data-theme'

export default gql`
  ${fragmentModuleNavigationLink}
  ${fragmentModuleMedia}
  ${fragmentGlobalDataTheme}
  fragment BlockCampaignsCallOutFragment on BlockCampaignsCallOut {
    title
    description {
      json
    }
    link {
      ...ModuleNavigationLinkFragment
    }
    image {
      ...ModuleMediaFragment
    }
    sys {
      id
    }
    orientation
    theme {
      ...GlobalDataThemeFragment
    }
  }
`
